import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9827c034")

_pushScopeId("data-v-9827c034")
const _hoisted_1 = { class: "HistoryFilters default-layout-padding" }
const _hoisted_2 = { class: "HistoryFilters__row" }
const _hoisted_3 = { style: {"display":"flex"} }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "HistoryFilters__divider" }, [
  /*#__PURE__*/_createVNode("span", { class: "HistoryFilters__line" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_switch = _resolveComponent("s-switch")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_s_search_input = _resolveComponent("s-search-input")!
  const _component_icon_filters = _resolveComponent("icon-filters")!
  const _component_ltl_filters = _resolveComponent("ltl-filters")!
  const _component_ltl_additional_filters = _resolveComponent("ltl-additional-filters")!
  const _component_s_modal = _resolveComponent("s-modal")!
  const _component_ftl_additional_filters = _resolveComponent("ftl-additional-filters")!
  const _component_express_additional_filters = _resolveComponent("express-additional-filters")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_s_switch, {
          theme: _ctx.isFTL ? 'red' : _ctx.isLTL ? 'primary' : 'blue',
          value: _ctx.historyFiltersState.type,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.historyFiltersState.type = $event)),
          options: _ctx.HISTORY_FILTERS_ORDERS_TYPES,
          onChange: _ctx.setBidsType
        }, null, 8, ["theme", "value", "options", "onChange"]),
        (!_ctx.isEXPRESS)
          ? (_openBlock(), _createBlock(_component_s_search_input, {
              key: 0,
              placeholder: _ctx.computedPlaceholder,
              value: _ctx.historyFiltersState.search_query,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.historyFiltersState.search_query = $event)),
              onSearch: _ctx.loadData
            }, _createSlots({ _: 2 }, [
              (_ctx.searchWithSelect)
                ? {
                    name: "select",
                    fn: _withId(() => [
                      _createVNode(_component_multiselect, {
                        modelValue: _ctx.historyFiltersState.search_type,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.historyFiltersState.search_type = $event)),
                        class: "search",
                        options: _ctx.getHistoryFiltersSearchOptions,
                        object: true,
                        canDeselect: false,
                        canClear: false,
                        label: "name"
                      }, null, 8, ["modelValue", "options"])
                    ])
                  }
                : undefined
            ]), 1032, ["placeholder", "value", "onSearch"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", {
        class: ["HistoryFilters__row", { ltl: _ctx.isLTL }]
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", {
            class: "HistoryFilters__additional",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openAdditionalFilters && _ctx.openAdditionalFilters(...args)))
          }, [
            _createVNode(_component_icon_filters, { class: "additional__icons" })
          ]),
          _hoisted_4,
          _createVNode(_component_multiselect, {
            class: "itemscount",
            modelValue: _ctx.historyFiltersState.items_count,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.historyFiltersState.items_count = $event)),
            options: _ctx.HISTORY_FILTERS_ITEMS_COUNT_OPTIONS,
            object: true,
            canDeselect: false,
            canClear: false,
            label: "name",
            onChange: _ctx.changeLimitHandler
          }, null, 8, ["modelValue", "options", "onChange"])
        ]),
        (_ctx.isLTL)
          ? (_openBlock(), _createBlock(_component_ltl_filters, { key: 0 }))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    (_ctx.LTLAdditionalFiltersIsOpened)
      ? (_openBlock(), _createBlock(_component_s_modal, {
          key: 0,
          onClose: _ctx.LTLAdditionalFiltersModal.closeModal
        }, {
          body: _withId(() => [
            _createVNode(_component_ltl_additional_filters, {
              onClose: _ctx.LTLAdditionalFiltersModal.closeModal
            }, null, 8, ["onClose"])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.FTLAdditionalFiltersIsOpened)
      ? (_openBlock(), _createBlock(_component_s_modal, {
          key: 1,
          onClose: _ctx.FTLAdditionalFiltersModal.closeModal
        }, {
          body: _withId(() => [
            _createVNode(_component_ftl_additional_filters, {
              onClose: _ctx.FTLAdditionalFiltersModal.closeModal
            }, null, 8, ["onClose"])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.ExpressAdditionalFiltersIsOpened)
      ? (_openBlock(), _createBlock(_component_s_modal, {
          key: 2,
          onClose: _ctx.ExpressAdditionalFiltersModal.closeModal
        }, {
          body: _withId(() => [
            _createVNode(_component_express_additional_filters, {
              onClose: _ctx.ExpressAdditionalFiltersModal.closeModal
            }, null, 8, ["onClose"])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ], 64))
})